<template>
<form id="find_bug" class="check_multiple_send" :inert="isLoading" :class="{ 'ajax_processed': isLoading }"
    @submit.prevent="onSubmit">
    <div class="popup_head">
        <span>Нашли ошибку? Сообщите нам!</span>
    </div>

    <div class="popup_cont">
        <div class="form_row" :class="{ 'error': v$.formData.comment.$errors.length }">
            <label for="find-bug-comment">Сообщение об ошибке на сайте<span class="req">*</span></label>
            <textarea id="find-bug-comment" v-model="formData.comment"></textarea>
        </div>
        <div class="clearfix">
            <div class="col_half">
                <div class="form_row" :class="{ 'error': v$.formData.name.$errors.length }">
                    <label for="find-bug-name">Имя<span class="req">*</span></label>
                    <input id="find-bug-name" type="text" v-model="formData.name">
                </div>
            </div>
            <div class="col_half">
                <div class="form_row" :class="{ 'error': v$.formData.email.$errors.length }">
                    <label for="find-bug-email">Эл. почта<span class="req">*</span></label>
                    <input id="find-bug-email" type="text" v-model="formData.email">
                </div>
            </div>
        </div>
        <div class="form_row">
            <label for="find-bug-url">URL страницы с ошибкой</label>
            <input id="find-bug-url" type="text" v-model="formData.url">
        </div>
        <div class="form_row required">
            <label>Прикрепите файл</label>
            <div v-for="(field, i) in fileFields" :key="field.id" class="bl_input_file"
                :class="{ 'bl_input_file--add': i !== 0 }">
                <template v-if="i === 0">
                    <input type="hidden" value="">
                    <input type="file" class="input-file" @change="($event) => onUploadFile(field.id, $event)">
                    <input type="text" class="filename"> <span>Обзор</span>
                </template>
                <template v-else>
                    <input type="hidden" value="">
                    <input type="file" class="input-file" @change="($event) => onUploadFile(field.id, $event)">
                    <input type="text" class="filename"><span>Обзор</span>
                    <span class="form_file_delete_link" @click="onDeleteFileField(field.id)">Удалить</span>
                </template>
            </div>
            <div class="bl_attention_file">Поддерживаемые форматы: doc, docx, txt, rtf, xls, xlsx, jpeg, jpg, png, avi
            </div>
            <button type="button" class="form_file_add_link btn btn_blue" @click="onAddFileField">Добавить ещё</button>
        </div>
        <div class="consent-accepted" v-if="confirmConsent">Согласие на обработку персональных данных принято</div>
    </div>

    <div v-if="!confirmConsent" class="confirm-consent">
        <div class="confirm-consent__text">
            Подтвердите <a href="/upload/Согласие.pdf" target="_blank">согласие</a> на обработку <br> Ваших персональных
            данных
        </div>
        <div class="confirm-consent__btn">
            <button class="btn btn_red" type="button" @click="confirmConsent = true">Подтвердить</button>
        </div>
    </div>
    <div v-else class="consent-block">
        <div class="consent-final">
            <div class="consent-final__text">
                Нажимая кнопку, Вы подтверждаете, что ознакомились с <a href="/upload/Политикa-конфиденциальности.pdf"
                    target="_blank">Политикой
                    конфиденциальности</a>
            </div>
            <div class="consent-final__btn">
                <div class="not-theme">
                    <input type="submit" value="Отправить" :disabled="isLoading" :class="{ 'loading': isLoading }" class="btn btn_red">
                </div>
            </div>
        </div>
    </div>
</form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core'
import { required, email, helpers } from '@vuelidate/validators'
const { withMessage } = helpers;
import { objectToFormData } from '../../utils/objectToFormData.js';
export default {
    name: 'FindBugForm',
    props: {
        items: {
            type: Object,
            default: () => ([]),
        }
    },
    setup() {
        return { v$: useVuelidate() }
    },
    data: () => ({
        formData: {
            comment: '',
            name: '',
            email: '',
            url: '',
        },
        fileFieldsCounter: 1,
        fileFields: [{ id: 0, file: null }],
        isLoading: false,
        confirmConsent: false,
    }),
    validations() {
        return {
            formData: {
                comment: {
                    required: withMessage('Обязательное поле', required)
                },
                name: {
                    required: withMessage('Обязательное поле', required)
                },
                email: {
                    required: withMessage('Введите корректный email', required),
                    email: withMessage('Введите корректный email', email),
                },
            }
        }
    },
    mounted() {
        this.formData.url = window.location.href;
    },
    computed: {
        ...mapGetters({
            getYandexSiteKey: 'getYandexSiteKey',
        })
    },
    watch: {},
    methods: {
        onAddFileField() {
            this.fileFields.push({ id: this.fileFieldsCounter++, file: null })
        },
        onUploadFile(id, e) {
            const field = this.fileFields.find(el => el.id === id);
            if (field) {
                field.file = e.target.files[0];
            }
        },
        onDeleteFileField(id) {
            this.fileFields = this.fileFields.filter(el => el.id !== id);
        },
        clearForm() {
            this.v$.$reset();
            this.formData = {
                comment: '',
                name: '',
                email: '',
            };
            this.fileFields = [{ id: this.fileFieldsCounter++, file: null }]
        },
        async onSubmit() {
            const isValid = await this.v$.$validate();
            if (!isValid) return
            this.isLoading = true;
            const isCaptchaStarted = await this.executeYandexCaptcha(() => this.sendForm());
            if (!isCaptchaStarted) {
                this.isLoading = false;
                window.showHeaderMessage('Не удалось загрузить проверку. Перезагрузите страницу и попробуйте ещё раз.', 'error');
            }
        },
        async sendForm() {
            this.isLoading = true;
            try {
                const files = this.fileFields.map(field => field.file);
                const payload = { ...this.formData, files: files, yatoken: window.smartCaptcha.getResponse() }
                const result = await fetch('/api/forms/find-bug/', {
                    method: 'POST',
                    body: objectToFormData(payload),
                });
                const data = await result.json();
                if (data.success) {
                    window.$.fancybox.close();
                    window.showHeaderMessage('Сообщение успешно отправлено');
                    this.clearForm();
                } else {
                    window.showHeaderMessage(data.error || 'Произошла ошибка', 'error');
                }
            }
            catch (error) {
                window.showHeaderMessage(error || 'Произошла ошибка', 'error');
            }
            finally {
                this.isLoading = false;
            }
        },
        ...mapActions({
            'executeYandexCaptcha': 'executeYandexCaptcha',
        }),
    },
}
</script>
